import React from 'react';
import cx from 'classnames';

import { FontAwesomeIcon } from '@magoosh/lib/icons';

import { Domain, Skill } from '@test_prep/app/ai_tutor/types';

import Button from '../button';
import { colorPaletteForSkill, SkillIcon } from '../icons';

interface Props {
  children: any;
  domain: Domain;
  href?: string;
  onClick?: () => void;
  skill?: Skill
  submitting?: boolean;
}

export default (props: Props) => {
  const colorPalette = colorPaletteForSkill(props.domain, props.skill);

  return (
    <Button
      colorPalette={colorPalette}
      href={props.href}
      icon={<SkillIcon domain={props.domain} size="sm" skill={props.skill} />}
      onClick={props.onClick}
    >
      {props.children}
    </Button>
  );
};
